<template>
  <background-section
    :image="backgroundImage"
    :class="{ 'py-12 text-white': backgroundImage }"
    class="VideoSection bg-black flex justify-center relative"
  >
    <div class="container">
      <div v-if="$slots['above-video']" class="pb-12">
        <slot name="above-video" />
      </div>
      <you-tube-player
        ref="player"
        :player-vars="options"
        :video-id="videoId"
        class="responsive-embed widescreen"
      />
    </div>
    <div
      v-if="hasCover && !isPLaying"
      :style="{ backgroundImage: `url(${require('@/assets/images/sections/home-video.jpg')})` }"
      class="VideoSection__overlay bg-cover bg-no-repeat flex justify-center items-center absolute pin text-white text-3xl"
    >
      <i
        class="mps mps-play mps-4x opacity-50 hover:opacity-75 ease cursor-pointer"
        @click="play"
      />
    </div>
  </background-section>
</template>

<script>
export default {
  name: 'VideoSection',
  props: {
    id: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    },
    hasCover: {
      type: Boolean,
      default: true
    },
    backgroundImage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isPLaying: false
    }
  },
  computed: {
    videoId ({ id }) {
      if (!id.startsWith('https://')) return id
      return id.split('?v=')[1]
    }
  },
  methods: {
    play () {
      this.isPLaying = true
      this.$refs.player.player.playVideo()
    }
  }
}
</script>

<style scoped>

</style>
